<template>
  <section class="sec-top-intro">
    <div class="box-top-slide">
      <div class="img-top-slide">
        <img src="@/assets/img/column/202601_01.png" />
      </div>
      <div class="img-top-slide_text">
        <h2 class="mb-0 text-right">化粧水・美容液・乳液の正しい順番とは？<br>そして知りたい、美容液の選び方。</h2>
      </div>
    </div>
  </section>

  <section class="column_content">

    <div class="pt-5 mt-5 text-center">
      <p class="mb-3">
      「化粧水、美容液、乳液の順番って？」<br>
      「美容液はいつ塗るの？」
      </p>
      <p class="mb-3">スキンケアについて調べると、情報が多すぎて迷ってしまうことはありませんか。</p>
      <p class="mb-3">スキンケアの順番に"間違えてはいけないルール"があるわけではありません。</p>
      <p class="mb-3">ただ、基礎化粧品の役割を理解した順番で使うことは、<strong>アイテムの力をより引き出しやすくなる</strong>というメリットがあります。</p>
      <p class="mb-3">この記事では、</p>
      <p class="mb-3"><strong>『化粧水・美容液・乳液の基本の順番』</strong></p>
      <p class="mb-3"><strong>『美容液はいつ使うのが正解なのか』</strong></p>
      <p class="mb-3"><strong>『自分に合った美容液の考え方』</strong></p>
      <p>を、わかりやすく解説していきます。</p>
    </div>

    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202601_02.png">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">結論：基本のスキンケアの順番</h3>
        <p class="mb-3">まず結論からお伝えすると、基本の順番は次の通りです。</p>
        <p class="mb-3"><strong>化粧水 → 美容液 → 乳液 or クリーム</strong></p>
        <p class="mb-3">この順番は、</p>
        <p class="mb-3">「水分を与える → 必要な成分を届ける → うるおいを逃がさない」</p>
        <p>という、肌のしくみに沿った流れになっています。</p>
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">なぜこの順番が基本？</h3>
        <p class="mb-3"><strong>それぞれの役割を知る</strong></p>
        <ul class="mb-3">
          <li class="mb-3">
            <strong>化粧水の役割</strong><br>
            化粧水は、肌に水分を与え、角層をやわらかく整える役割があります。<br>
            肌がうるおっていることで、その後に使う美容液の成分がなじみやすくなります。
          </li>
          <li class="mb-3">
            <strong>美容液の役割</strong><br>
            美容液は、乾燥、ハリ不足、くすみなど、<strong>肌悩みにアプローチするためのアイテム</strong>です。<br>
            スキンケアの中でも、いわば"目的別ケアの中心"となる存在です。
          </li>
          <li>
            <strong>乳液・クリームの役割</strong><br>
            乳液やクリームは、油分によってフタをする役割があります。<br>
            化粧水や美容液で与えた水分や成分が逃げないよう、肌を守ります。
          </li>
        </ul>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202601_03.png">
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">美容液には「悩み別」にさまざまな種類がある</h3>
        <p class="mb-3">美容液とひと口に言っても、その種類はさまざまです。</p>
        <p class="mb-3">例えば、</p>
        <ul class="mb-3">
          <li><strong>乾燥が気になるとき</strong></li>
          <li><strong>ハリや弾力が気になるとき</strong></li>
          <li><strong>肌のごわつきやくすみが気になるとき</strong></li>
          <li><strong>季節の変わり目で肌が不安定なとき</strong></li>
        </ul>
        <p class="mb-3">など、肌状態によって必要な美容液は変わります。</p>
        <p class="mb-3">すべてを使う必要はなく、<strong>今の自分の肌に必要なものを選ぶこと</strong>が大切です。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202601_04.png">
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202601_05.png">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">「自分に合った美容液」を選ぶための考え方</h3>
        <p class="mb-3">美容液選びで迷ったときは、成分名や流行よりも、</p>
        <p class="mb-3"><strong>「最近、肌がどう感じているか」</strong>に目を向けてみてください。</p>
        <ul class="mb-3">
          <li><strong>乾燥しやすい</strong></li>
          <li><strong>以前よりハリが出にくい</strong></li>
          <li><strong>肌がゆらぎやすい</strong></li>
        </ul>
        <p class="mb-3">こうした小さな変化に気づくことが、スキンケア選びの第一歩です。</p>
        <p class="mb-3">肌悩みは季節や生活リズムによって変わるもの。</p>
        <p class="mb-3">その時々の肌に合わせて選ぶ意識が、無理のないケアにつながります。</p>
      </div>
    </div>

    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">美容液はいつ塗るのが正解？</h3>
        <p class="mb-3">よくある質問が、<strong>「美容液はいつ塗ればいいの？」</strong>という疑問です。</p>
        <p class="mb-3">基本的な答えは、</p>
        <p class="mb-3"><strong>化粧水のあと、乳液の前</strong>です。</p>
        <p class="mb-3">化粧水で肌が整い、水分を含んだ状態のほうが、美容液の成分がなじみやすくなります。</p>
        <p class="mb-3">そのあとに乳液やクリームでフタをすることで、うるおいを保ちやすくなります。</p>
        <p class="mb-3">オイルタイプやブースタータイプなど、一部例外はありますが、基本はこの順番がおすすめです。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202601_06.png">
      </div>
    </div>

    <div class="pt-5 mt-5 text-center">
      <h3 class="mb-3">つまり・・・</h3>
      <p>スキンケアの順番は、厳しいルールではなく</p>
      <p><strong>肌にとって心地よく、効率よくケアするための工夫</strong>です。</p>
      <p><strong>基本は「化粧水 → 美容液 → 乳液」</strong></p>
      <p><strong>美容液は悩み別に選ぶ</strong></p>
      <p><strong>大切なのは、自分の肌を知り、続けられるケアをすること</strong></p>
      <p>毎日の積み重ねが、健やかな美しい肌につながっていきます。</p>
    </div>

    <div class="layer_01  my-5 py-5">
      <img src="@/assets/img/column/layer-bg_01.jpg">
      <div class="layer-text">
        <p class="mb-3">スキンケアの基本を理解したうえで次に重要になるのは、自分の肌悩みに応じて美容液を選ぶという視点です。</p>
        <p class="mb-3">とくに美容液は、乾燥やハリ不足、肌のゆらぎなど、特定の悩みにアプローチする役割を担います。</p>
        <p class="mb-3">化粧水で肌を整えたあとに美容液を使い、乳液でうるおいを保持することで、成分を効率よく肌に届けやすくなります。</p>
        <p>順番と役割を意識しながら、その時の肌状態に合った美容液を取り入れることが、無理のない継続的なケアにつながります。</p>
      </div>
    </div>
    
  </section>


  <!-- トップに戻るボタン -->
  <button id="page-top" class="btn" v-on:click="scrollTop">
    TOP
  </button>

</template>

<style scoped>
.column_content h2,.column_content h3 {
  font-weight: 500 !important;
}
small {
  font-size: .7em;
}
ul {
  list-style: disc;
  margin-left: 25px;
}

.feature-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 50px;
}
.feature-row_item_image img {
  width: 100%;
}
.feature-row_item_text h3 {
  font-size: 1.25em;
}

button#page-top {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 100;
}


.layer_01 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('../../assets/img/column/layer-bg_01.jpg');
  background-size: cover;
  background-position: center;
  min-height: 500px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
  padding: 20px; /* テキストと画像の端の間に余白を設定 */
}
.layer_01 img {
  display: none; /* 画像は背景として使用するので非表示にします */
}
.layer_01 .layer-text {
  /* padding: 10px; */
  text-align: center;
  max-width: 90%; /* 文字が画像からはみ出さないように最大幅を設定 */
  word-wrap: break-word; /* 長い単語が折り返されるようにする */
  color: #424242;
  font-weight: 500;
}
.layer_01 .layer-text .fs-2 {
  font-size: 2em;
}

.feature-row_product_list {
  align-items: inherit;
  justify-content: flex-start;
}
.feature-row_column_list {
  align-items: inherit;
  justify-content: center;
}
.feature-row_product_item {
  width: 25%;
  padding: 5px;
  text-align: center;
}
.feature-row_column_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}
.feature-row_product_detail {
  color: #333;
}
.feature-row_product_cate {
  font-size: .8em;
  color: #6b6b67;
  opacity: .65;
}
.feature-row_voice_list {
  align-items: baseline;
}
.feature-row_voice_list path.a {
  fill: none;
  stroke: #000;
  stroke-width: 2px;
}
.feature-row_voice_list .icon svg {
  width: 70px;
}
.feature-row_voice_list .feature-row_voice_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}

.box-top-slide {
  position: relative;
}
.img-top-slide img {
  width: 100%;
  height: 422px;
  object-fit: cover;
  object-position: left;
}
.img-top-slide_text {
  position: absolute;
  bottom: 30px;
  right: 30px;
  color: #fff;
}
.img-top-slide_text h2 {
  font-size: 2em;
  font-weight: 500 !important;
}
.img-top-slide_text h2 span {
  font-size: .6em;
}

.layer_02 .layer-text,.layer_03 .layer-text,.layer_04 .layer-text {
  background-color: #cacaca;
  padding: 10px;
}
.layer_02 .layer-text .layer-text-inner,.layer_03 .layer-text .layer-text-inner,.layer_04 .layer-text .layer-text-inner {
  background-color: #fff;
  padding: 15px;
}
.layer_02 .layer-text .layer-text-inner h2 span,.layer_03 .layer-text .layer-text-inner h2 span,.layer_04 .layer-text .layer-text-inner h2 span {
  font-size: .6em;
}
@media screen and (min-width: 991px) {
    .layer_02 {
      position: relative;
      display: flex;
      align-items: flex-start;
      background-image: url('../../assets/img/column/202501_05.jpg');
      background-size: cover;
      min-height: 600px;
      padding: 60px;
    }
    .layer_03 {
      position: relative;
      display: flex;
      align-items: flex-start;
      background-image: url('../../assets/img/column/202501_06.jpg');
      background-size: cover;
      min-height: 600px;
      padding: 60px;
    }
    .layer_04 {
      position: relative;
      display: flex;
      align-items: flex-start;
      background-image: url('../../assets/img/column/202501_07.jpg');
      background-size: cover;
      min-height: 600px;
      padding: 60px;
    }
    .layer_02 img,.layer_03 img,.layer_04 img {
      display: none; /* 画像は背景として使用するので非表示にします */
    }
    .layer_02 .layer-text,.layer_03 .layer-text,.layer_04 .layer-text {
      padding: 15px;
      max-width: 45%; /* 文字が画像からはみ出さないように最大幅を設定 */
      word-wrap: break-word; /* 長い単語が折り返されるようにする */
      color: #424242;
      background-color: #fff;
    }
}
@media screen and (max-width: 699px) {
    .img-top-slide_text h2 {
      font-size: inherit;
    }
    .img-top-slide_text h2 span {
      font-size: .8em;
    }
    .img-top-slide_text {
      left: 10px;
    }
}
@media screen and (min-width: 769px) {
   .feature-row_item_text_right {
    padding-left: 60px;
   }
   .feature-row_item_text_left {
    padding-right: 60px;
   }
   .w-40 {
    width: 40%;
   }
   .w-60 {
    width: 60%;
   }
   .feature-row.step .step-item {
    width: 33.33%;
   }
   .img-top-slide img {
    height: 650px;
   }
}
@media screen and (min-width: 1px) and (max-width: 768px) {
  .column_content h2 {
    margin-bottom: 40px;
  }
  .feature-row {
    flex-direction: column;
  }
  .feature-row_item_image {
    order: 1;
    margin-bottom: 15px;
  }
  .feature-row_item_text {
    order: 2;
  }
  .feature-row_voice_item, .feature-row_product_item, .feature-row_column_item {
      width: 100% !important;
  }
  .w-50, .w-25, .w-75 {
    width: 100% !important;
  }
  .layer-text {
    font-size: .8em;
  }
  .layer_01 .layer-text .fs-2 {
    font-size: 1.5em;
  }
}
</style>

<script>
import $ from "jquery";

$(function() {
 var topBtn = $('#page-top');    
 topBtn.hide();
 //スクロールが500に達したらボタン表示
 $(window).scroll(function () {
 if ($(this).scrollTop() > 500) {
 topBtn.fadeIn();
        } else {
 topBtn.fadeOut();
        }
    });
    
});

// ページ内リンク
export default{
  data: () => {
    return {isActive: []}
  },
  mounted (){
    window.scroll(0, 0);
    for(let i = 0; i < 2; i++) {
      this.isActive[i] = false
    }
  },
  methods: {
    scrollToAnchorPoint(refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({ behavior: 'smooth'})
    },
    openInfo(ref) {
      console.log(ref)
      this.isActive[ref] = true
      console.log(this.isActive[ref])
    },
    closeInfo(ref) {
      console.log(ref)
      this.isActive[ref] = false
      console.log(this.isActive[ref])
    },
    scrollTop(){
      window.scrollTo({
      top: 0,
      behavior: "smooth"
      })
    }
  }
}

</script>